import { useSearchParams } from "react-router-dom";
const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const setQueryParam = (key, value) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set(key, value);
        setSearchParams(newParams);
    };
    const getQueryParam = (key) => {
        return searchParams.get(key);
    };
    return { setQueryParam, getQueryParam };
};
export default useQueryParams;
